module.exports = __webpack_public_path__ + "static/media/buy_req_rent_10.eb7c20ab.png";